export const dispatchCustomFilterEvent = (eventName: string, detailValue: string) => {
  const event = new CustomEvent(eventName, { detail: detailValue })
  window.dispatchEvent(event)
}
